import { render, staticRenderFns } from "./web-recorder.vue?vue&type=template&id=42bb373e"
import script from "./web-recorder.vue?vue&type=script&lang=js"
export * from "./web-recorder.vue?vue&type=script&lang=js"
import style0 from "./web-recorder.vue?vue&type=style&index=0&id=42bb373e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports